import { useCallback } from 'react';

interface ScrollToOptions {
  offset?: number;
  behavior?: ScrollBehavior;
}

export const useScrollTo = () => {
  const scrollTo = useCallback(
    ({ offset = 0, behavior = 'smooth' }: ScrollToOptions = {}) => {
      window.scrollTo({
        top: offset,
        behavior,
      });
    },
    []
  );

  return scrollTo;
};

export const useScrollToElementId = () => {
  const scrollToElement = useCallback(
    (elementId: string, options: ScrollToOptions = {}) => {
      const element = document.getElementById(elementId);
      if (element) {
        const offset = options.offset || 0;
        window.scrollTo({
          top: element.offsetTop - offset,
          behavior: options.behavior || 'smooth',
        });
      }
    },
    []
  );

  return scrollToElement;
};
